// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_5oB","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_Gg6 FallbackBulkDownloadUpsellModalControl-cls1_5oB"};